<template>
    <page-wrap class="grxx">
        <el-card class="box-card"  style="width: 100%;" shadow="never">
            <h2 class="xpqd">个人信息</h2>
            <el-form ref="form" :model="fromPerson" label-width="200px" onsubmit="return false" style="width: 700px">
                <el-form-item label="联系人姓名:" required>
                    <el-input v-model="fromPerson.contact" class="input-item" placeholder=""></el-input>
                </el-form-item>
                <el-form-item label="认证手机:" required>
                    <el-input v-model="fromPerson.phone" class="input-item" disabled></el-input>
                </el-form-item>
                <el-form-item label="性别:" required>
                    <el-radio-group v-model="fromPerson.gender">
                        <el-radio :label="1">男</el-radio>
                        <el-radio :label="2">女</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="QQ:">
                    <el-input v-model="fromPerson.qq" class="input-item" placeholder="QQ"></el-input>
                </el-form-item>
                <el-form-item label="电子邮箱:">
                    <el-input v-model="fromPerson.email" class="input-item" placeholder="电子邮箱"></el-input>
                </el-form-item>
                <el-form-item label="传真:">
                    <el-input v-model="fromPerson.fax_number" class="input-item" placeholder="传真"></el-input>
                </el-form-item>
                <el-form-item label="固定电话:">
                    <el-input v-model="fromPerson.tel_area" class="input-item" placeholder="区号"
                              style="width: 70px"></el-input>
                    <el-input v-model="fromPerson.telephone" class="input-item" placeholder="电话号码"></el-input>
                </el-form-item>
              <el-form-item label="新密码:">
                <el-input v-model="new_password" class="input-item" placeholder="填写代表更改密码"></el-input>
              </el-form-item>
              <el-form-item label="再次输入新密码:">
                <el-input v-model="new_password_again" class="input-item" placeholder="填写与新密码一致"></el-input>
              </el-form-item>
                <el-form-item class="submit_but">
                    <el-button type="primary" @click="submitInfo" >保存</el-button>
                </el-form-item>
            </el-form>
        </el-card>
    </page-wrap>
</template>
<style>
    .input-item {
        width: 350px;
    }
</style>
<script>
    export default {
        data() {
            return {
                fromPerson: {
                    contact: '',
                    phone: '',
                    gender: 1,
                    qq: '',
                    email: '',
                    tel_area: '',
                    telephone: '',
                    fax_number:''
                },
                new_password : '',
                new_password_again : '',
            }
        }, mounted() {
            this.getInfo()
        },
        methods: {
            getInfo() {
                let that = this
                this.$ajax.get('business/person/getInfo').then(function (res) {
                    if (res.data.error === 0) {
                        that.fromPerson = res.data.data
                    }
                })
            },
            submitInfo() {
                let that = this
                this.fromPerson.new_password = this.new_password
                this.fromPerson.new_password_again = this.new_password_again
                this.$ajax.post('business/person/postInfo', this.fromPerson).then(function (res) {
                    if (res.data.error === 0) {
                        that.$message.success('保存成功');
                    } else {
                        that.$message.error(res.data.message)
                    }
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/business/Person.vue